import React, { useState, useEffect, useRef } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ImageSlider() {
  const [images, setImages] = useState([]);
  const [slideIndex, setSlideIndex] = useState(0);
  const [autoSlide, setAutoSlide] = useState(true);
  const sliderRef = useRef(null);


  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Images?type=advertisement`);
        if (!response.ok) throw new Error('Failed to fetch advertisement images');

        const data = await response.json();
        setImages(data);
      } catch (error) {
        // Silent fail (previously only 1 console.error line in this catch block, no other actions)
      }
    };

    fetchImages();
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    if (autoSlide && images.length > 0) {
      const interval = setInterval(() => {
        goToNextSlide();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [autoSlide, images.length, slideIndex]);

  const handleManualNavigation = () => {
    setAutoSlide(false);
    // Resume auto-slide after 8 seconds
    setTimeout(() => setAutoSlide(true), 8000);
  };

  const goToSlide = (index) => {
    setSlideIndex(index);
    handleManualNavigation();
  };

  const goToNextSlide = () => goToSlide((slideIndex + 1) % images.length);
  const goToPrevSlide = () => goToSlide((slideIndex - 1 + images.length) % images.length);

  return (
    <div className="homepage-image-slider-container">
      <div className="homepage-image-slider-slideshow">
        <div
          className="homepage-image-slider"
          ref={sliderRef}
          style={{ transform: `translateX(-${slideIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={image.id} className="homepage-image-slider-slide">
              <div className="homepage-image-slider-number">{index + 1} / {images.length}</div>
              <img
                src={`data:image/jpeg;base64,${image.imageData}`}
                alt={`Advertisement Image ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <button className="homepage-image-slider-prev" onClick={goToPrevSlide}>&#10094;</button>
      <button className="homepage-image-slider-next" onClick={goToNextSlide}>&#10095;</button>

      {/* Dots Navigation */}
      <div className="homepage-image-slider-dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`homepage-image-slider-dot ${index === slideIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default ImageSlider;